import React, { useState } from "react";
import "../../styles/AdmissionsPage.css";
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import api from "../../utils/api";

const FirstYearAdmission = () => {
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const [submitting, setSubmitting] = useState(false);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    dob: "",
    address: "",
    course: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const submitForm = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      await api.post("/admissions/apply", {
        ...form,
        year: "FY",
      });

      alert("Admission form submitted successfully");
      setShowModal(false);
      setForm({
        name: "",
        email: "",
        phone: "",
        dob: "",
        address: "",
        course: "",
      });
    } catch (error) {
      console.error(error.response?.data || error.message);
      alert(error.response?.data?.message || "Submission failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      < Navbar />
      <div className="admission-container-fya fade-in">
        <h1 className="page-title">First Year Admission</h1>
        <p className="intro-text">
          Welcome to the First Year Admission section of Shri Mulikadevi Mahavidyalaya,
          Nighoj. Here you’ll find complete details regarding eligibility, required
          documents, important dates, and the admission process for first-year students.
        </p>

        <div className="admission-card">
          <h2 className="card-title">✅ Confirmation</h2>
          <p className="card-text">
            Receive confirmation of admission and pay the fees.
          </p>
        </div>

        <div className="admission-card">
          <h2 className="card-title">📄 Required Documents</h2>
          <ul className="card-list">
            <li>10th & 12th Marksheet</li>
            <li>Transfer Certificate</li>
            <li>Aadhar Card Copy</li>
            <li>Caste Certificate (if applicable)</li>
            <li>Passport-size Photos</li>
          </ul>
        </div>

        <div className="admission-card">
          <h2 className="card-title">📅 Important Dates</h2>
          <ul className="card-list">
            <li>Application Start Date: <strong>June 1, 2025</strong></li>
            <li>Last Date to Apply: <strong>July 10, 2025</strong></li>
            <li>Document Verification: <strong>July 15–20, 2025</strong></li>
            <li>Admission Confirmation: <strong>July 25, 2025</strong></li>
          </ul>
        </div>

        <div className="btn-container">
          <button className="apply-btn" onClick={handleOpenModal}>
            Apply Now
          </button>
        </div>

        {/* ==== Modal ==== */}
        {showModal && (
          <div className="modal-overlay">
            <div className="modal">
              <button className="adm-close-btn" onClick={handleCloseModal}>
                &times;
              </button>
              <h2 className="modal-title">Admission Form</h2>

              <form className="admission-form" onSubmit={submitForm}>
                <label>Full Name</label>
                <input type="text" value={form.name} name="name" placeholder="Enter your full name" required onChange={handleChange} />

                <label>Email</label>
                <input type="email" value={form.email} name="email" placeholder="Enter your email" required onChange={handleChange} />

                <label>Phone Number</label>
                <input type="tel" value={form.phone} name="phone" placeholder="Enter your phone number" required onChange={handleChange} />

                <label>DOB</label>
                <input name="dob" value={form.dob} type="date" required onChange={handleChange} />

                <label>Address</label>
                <input name="address" value={form.address} placeholder="Enter your address" required onChange={handleChange} />

                <label>Course Applying For</label>
                <select name="course" value={form.course} required onChange={handleChange}>
                  <option value="">Select Course</option>
                  <option value="B.Sc. Computer Science">B.Sc. Computer Science</option>
                  <option value="B.A.">B.A.</option>
                  <option value="B.Sc.">B.Sc.</option>
                </select>

                {/* ==== Upload File ==== */}

                {/*
              <label>Upload Marksheet (PDF)</label>
              <input type="file" accept=".pdf" />
              */}

                <button
                  type="submit"
                  className="submit-btn"
                  disabled={submitting}
                >
                  {submitting ? "Submitting..." : "Submit Application"}
                </button>
              </form>
            </div>
          </div>
        )}
      </div>
      < Footer />
    </>
  );
};

export default FirstYearAdmission;
